import {i18n} from "ui/i18n";
import Form, {EVENT_FIELD_CHANGE} from "ui/elements/form/Form";
import ToolBox from "ui/editor/toolboxes/ToolBox";
import {EVENT_CHANGE_TOOL} from "ui/canvas/Canvas";

export default class AnglePicker extends ToolBox {
	/**
	 * @param {object} options
	 */
	constructor(options) {
		super(Object.assign({
			title: i18n('title.angle-picker')
		}, options));

		this.setBodyElement(
			this._createForm()
		);

		this.scene.canvas.events.addListener(EVENT_CHANGE_TOOL, (tool) => {
			this.toggle(tool === 'ellipse');
		});
	}

	/**
	 * @private
	 */
	_createForm() {
		this._form = new Form({
			modifier: 'form_no-captions form_no-margin',
			values: {angle: '0'},
			fields: [
				{
					name: 'angle',
					type: 'angle90',
					caption: '',
				}
			]
		});

		this._form.events.addListener(EVENT_FIELD_CHANGE, ({value}) => {
			this.scene.canvas.setToolAngle(parseInt(value));
		});

		return this._form.getElement();
	}
}
